import React, { useEffect } from "react";
import {
  BrowserRouter,
  Switch,
  Route,
  Router,
  Redirect,
} from "react-router-dom";
import "./App.css";
import "./assets/css/material-dashboard-react.css?v=1.9.0";
import Admin from "./layouts/Admin";
import Vendor from "./layouts/Vendor";
import Driver from "./layouts/Driver";
import user from "./routes/user";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { createBrowserHistory } from "history";
import store from "./store/reducers/rootReducer";
import VendorLogin from "./components/Vendor/login/Login";
import DriverLogin from "./components/Driver/login/Login";
import AdminLogin from "./components/Admin/login/Login";
import { getCommission } from "./store/actions/admin/Admin";
import UserDashboard from "./components/User/SignIn/UserDashboard";
import Interceptor from "./services/Interceptor";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import RTL from "./layouts/RTL.js";
import moment from "moment";
import "moment-timezone";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import MySnackbar from "./components/MySnackBar";
import BackDrop from "./components/User/Preloader/BackDrop";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EmailIcon from "@material-ui/icons/Email";

//const URL = 'https://grospick.com/api'
const URL = "https://travelpick-2.onrender.com";
Interceptor.interceptor(store);

require("moment-timezone");
// moment.tz.setDefault('America/Los_Angeles');
axios.defaults.baseURL = process.env.NODE_ENV === "development" ? URL : URL;
// axios.defaults.baseURL = 'https://api.grospick.com/api_v_1'
const hist = createBrowserHistory();
const token = localStorage.getItem("token");

window.axios = axios;

// navigator.serviceWorker.addEventListener("message", (message) => {
//   const data = message.data
//   let messageData = {}
//   if (data.data) {
//     messageData = data.data

//   } else {
//     messageData = data['firebase-messaging-msg-data'].data
//   }
//   if (messageData.title === 'Sorry') {
//     toast.error(messageData.body, {
//       position: "bottom-right",
//       autoClose: 5000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       icon: EmailIcon,
//     });
//   }
//   else {
//     toast.success(messageData.body, {
//       position: "bottom-right",
//       autoClose: 5000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       icon: EmailIcon,
//     });
//   }
// });

if (token) {
  const decodeToken = jwtDecode(token);
  if (decodeToken.exp * 1000 < Date.now()) {
    localStorage.removeItem("latitude");
    localStorage.removeItem("longitude");
    localStorage.removeItem("uid");
    localStorage.removeItem("city");
    localStorage.removeItem("cost");
    localStorage.removeItem("promoCost");
    localStorage.removeItem("totalCost");
    localStorage.removeItem("token");
    localStorage.removeItem("userLoginType");

    window.location.href = "/";
  } else {
    store.dispatch({ type: "USER_LOGIN" });
    axios.defaults.headers.common["Authorization"] = token;
  }
}

function Alert(props) {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      {...props}
      style={{ width: "400px" }}
    />
  );
}

function App(props) {
  const { success_message, error_message, api_progress, auth } = props.user;

  useEffect(() => {
    //Loading Admin commission globally
    if (window.location.hostname === "travel.grospick.com") {
      document.title = "GrospickTravel";
    } else {
      document.title = "Travelpick.io";
    }
    store.dispatch(getCommission());
  }, []);

  const success = (message) => {
    setTimeout(function () {
      store.dispatch({ type: "SUCCESS_MESSAGE", payload: { data: "" } });
    }, 5000);
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={true}
        autoHideDuration={5000}
      >
        <Alert severity="success">{message}</Alert>
      </Snackbar>
    );
  };
  const error = (message) => {
    setTimeout(function () {
      store.dispatch({ type: "ERROR_MESSAGE", payload: { data: "" } });
    }, 5000);
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={true}
        autoHideDuration={5000}
      >
        <Alert severity="error">{message}</Alert>
      </Snackbar>
    );
  };

  return (
    <div className="App" style={{ backgroundColor: "#fafafa" }}>
      {success_message.general !== undefined
        ? success(success_message.general)
        : ""}
      {error_message.error !== undefined ? error(error_message.error) : ""}
      {error_message.error === undefined && error_message.message !== undefined
        ? error(error_message.message)
        : ""}
      {error_message.general !== undefined ? error(error_message.general) : ""}
      {/* <BackDrop open={api_progress}></BackDrop> */}
      <BrowserRouter basename="/">
        <Switch>
          <Route exact path="/driver/login" component={DriverLogin} />
          <Route exact path="/vendor/login" component={VendorLogin} />
          <Route exact path="/admin/login" component={AdminLogin} />
          <Route path="/admin" component={Admin} />
          <Route path="/user" component={UserDashboard} />
          <Route path="/vendor" component={Vendor} />
          <Route path="/driver" component={Driver} />
          <Route path="/" component={user} />
          <Router history={hist}>
            <Switch>
              <Route path="/admin" component={Admin} />
              <Route path="/rtl" component={RTL} />
              <Redirect from="/" to="/admin/dashboard" />
            </Switch>
          </Router>
        </Switch>
      </BrowserRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        icon={false}
      />
    </div>
  );
}
const mapPropsWithState = (state) => ({
  user: state.user,
  auth: state.user.auth,
});
export default connect(mapPropsWithState, null)(App);
